import { createSlice } from '@reduxjs/toolkit'

const InitState = {
        email:'',
        password:'',
        token: '',
}

export const loginSlice  = createSlice({
    name:'login',
    initialState : InitState,
    reducers:{
        loginState:(state,action)=>{
            state[action.payload.name] = action.payload.value
        },
        clearUserData: (state) => {
            state.token = ''
            state.email = ''
            state.password = ''
            localStorage.clear()
        }
    },
})

export const { loginState, clearUserData } = loginSlice.actions

export default loginSlice.reducer   